/** Normalize inbox Hotel filter — empty array means "All". */
export function normalizeHotelSelection(value) {
  if (Array.isArray(value)) {
    return value.map((v) => String(v).trim()).filter(Boolean)
  }
  if (value == null || value === "" || value === "all") return []
  return [String(value).trim()]
}

/** Normalize inbox Location filter — empty array means "All". */
export function normalizeLocationSelection(value) {
  if (Array.isArray(value)) {
    return value.map((v) => String(v).trim()).filter((v) => v !== "")
  }
  if (value == null || value === "" || value === "all") return []
  return [String(value).trim()]
}

export function isHotelFilterAll(value) {
  return normalizeHotelSelection(value).length === 0
}

export function isLocationFilterAll(value) {
  return normalizeLocationSelection(value).length === 0
}

export function hotelSelectionsEqual(a, b) {
  const left = normalizeHotelSelection(a).slice().sort()
  const right = normalizeHotelSelection(b).slice().sort()
  return left.length === right.length && left.every((v, i) => v === right[i])
}
